// @ts-nocheck
import { AccordionSectionPanel, AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection";
import getColor from "@insite/mobius/utilities/getColor";
import resolveColor from "@insite/mobius/utilities/resolveColor";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { focusStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

const borderWidth = pxToRem(1);
const borderCss = css`
    ${({ theme }) => `${borderWidth} solid ${resolveColor("common.border", theme)}`}
`;

const _headerButtonBaseStyles = () => {
    return css`
        ${focusStyles()}
        /* Store Custom Code - Start */
        padding: ${pxToRem(15, 0)};
        background-color: transparent;
        border: none;
        /* Store Custom Code - Removed border-top */
        /* Store Custom Code - Removed border-bottom */
        color: inherit;
        transition: ${transitionHoverStyles("color")};
        text-transform: uppercase;
        /* Store Custom Code - End */

        ${({ theme }) => css`
            /* Store Custom Code - Start */
            font-family: ${theme.design.typography.fontFamily.title};
            font-size: ${theme.design.typography.size.large};
            /* Store Custom Code - End */
            font-weight: ${theme.design.typography.weight.bold};
            line-height: ${theme.design.typography.lineHeight.small};
        `}

        &[aria-expanded="true"] {
            border-bottom-color: transparent;
        }

        &:hover {
            color: ${getColor("secondary.main")}; /* Store Custom Code */
        }
    `;
};

const _headerButtonStyles = () => {
    return css`
        button {
            ${_headerButtonBaseStyles()}

            &:focus,
            &:focus-visible {
                ${_headerButtonBaseStyles()}
            }
        }
    `;
};

export const accordionFooterSectionProps: AccordionSectionPresentationProps = {
    headerProps: {
        css: css`
            ${_headerButtonStyles()}
            background-color: transparent;

            ${AccordionSectionPanel} + && {
                ${_headerButtonStyles()}
                margin-top: -${borderWidth};
            }
        `,
    },
    panelProps: {
        css: css`
            padding: ${pxToRem(5, 0, 17)}; /* Store Custom Code */
            border: none;
            /* Store Custom Code - Removed border */
        `,
    },
    // Store Custom Code
    toggleIconProps: {
        color: "primary.contrast",
    },
};
